/* import __COLOCATED_TEMPLATE__ from './video-splash.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import templateOnlyComponent from '@ember/component/template-only';

interface VideoSplashSignature {
  Args: {
    isActive: boolean;
    headline: string;
    description: string;
    ctaLabel: string;
    openUpgradeModal: () => void;
    learnMoreHref: string;
    subHeading: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const VideoSplash = templateOnlyComponent<VideoSplashSignature>();
export default VideoSplash;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Paywalls::VideoSplash': typeof VideoSplash;
  }
}
